<template>
    <div class="Inventory">


        <!--INVENTORY MODAL-->
        <b-modal ref="modal-inventory" size="lg" title="INVENTORY MANAGEMENT" hide-footer>
            <b-container>
                <b-row>
                    <b-col>
                        <h2>
                            Inventory for {{MedicationName}} {{MedicationStrength}}
                            <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewInventory()" class="olive-green-text pointer" />
                        </h2>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <form class="table-filters">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Status:</label>
                                        <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable()">
                                            <option value="Present">Present in Inventory</option>
                                            <option value="Open">Open</option>
                                            <option value="Refill">Refills</option>
                                            <option value="Depleted">Depleted (Closed)</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="overflow-x:auto;">
                            <vuetable :fields="TableOptions.Fields"
                                      pagination-path=""
                                      :api-mode="false"
                                      class="vue-datatable"
                                      :data-manager="DataManager"
                                      ref="datatableinv">

                                <template slot="Edit" scope="props">
                                    <div class="Edit">
                                        <font-awesome-icon :icon="['fa', 'edit']" v-on:click="ShowEdit(props.rowData)" class="pointer" />
                                    </div>
                                </template>
                                <template slot="DateFilled" scope="props">
                                    <div class="DateFilled">
                                        <span>{{formatDate(props.rowData.DateFilled,'MM/DD/YY','N/A')}}</span>
                                    </div>
                                </template>
                                <template slot="ExpirationDate" scope="props">
                                    <div class="ExpirationDate">
                                        <span>{{formatDate(props.rowData.ExpirationDate,'MM/DD/YY','N/A')}}</span>
                                    </div>
                                </template>
                            </vuetable>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>



                <!--NEW / EDIT INVENTORY MODAL-->
                <b-modal ref="modal-edit" size="lg" title="Inventory Detail" hide-footer>
                    <b-container>
                        <b-form @submit="Save">
                            <b-row>
                                <b-col>
                                    <h3>Pharmacy Info</h3>
                                    <div class="form-group">
                                        <label>Pharmacy Name:</label>
                                        <input v-model="TargetRecord.PharmacyName" type="text" class="form-control" required />
                                    </div>
                                    <div class="form-group">
                                        <label>Pharmacy Phone Number:</label>
                                        <input v-model="TargetRecord.PharmacyPhoneNumber" type="text" class="form-control" required />
                                    </div>

                                </b-col>
                                <b-col>
                                    <h3>Refill Info</h3>
                                    <div class="form-group">
                                        <label>Rx Number:</label>
                                        <input v-model="TargetRecord.PrescriptionNumber" type="text" class="form-control" required />
                                    </div>
                                    <div class="form-group">
                                        <label>Quantity Filled (use actual in package):</label>
                                        <input v-model="TargetRecord.QuantityFilled" type="number" step="0.1" class="form-control" required />
                                    </div>
                                    <div class="form-group">
                                        <label>Refills Remaining:</label>
                                        <input v-model="TargetRecord.RefillsRemaining" type="number" step="1" class="form-control" required />
                                    </div>
                                    <div class="form-group">
                                        <label>Date Filled:</label>
                                        <flat-pickr v-model="TargetRecord.DateFilled" class="form-control" :config="DateConfig" required></flat-pickr>
                                    </div>
                                    <div class="form-group">
                                        <label>Expiration Date:</label>
                                        <flat-pickr v-model="TargetRecord.ExpirationDate" class="form-control" :config="DateConfig" required></flat-pickr>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="modal-btn-row">
                                <div class="modal-btn-row-div">
                                    <b-button size="md" variant="secondary" @click="CancelEdit()">
                                        CANCEL
                                    </b-button>
                                    <b-button size="md" variant="success" type="submit">
                                        SAVE
                                    </b-button>
                                    <b-button v-if="TargetRecord.Id" size="md" variant="danger" typeof="button" @click="DeleteInventory()">
                                        DELETE
                                    </b-button>
                                </div>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <h2 class="center-text">Destruction Log <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetDestructions()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewDestruction()" class="olive-green-text pointer" /></h2>
                                </b-col>
                            </b-row>
                            <b-row v-if="TargetRecord.Id">
                                <b-col>
                                    <div style="overflow-x:auto;">
                                        <vuetable :fields="DestructionTableOptions.Fields"
                                                  pagination-path=""
                                                  :api-mode="false"
                                                  class="vue-datatable"
                                                  :data-manager="DataManagerDestruction"
                                                  ref="datatabledest">

                                            <template slot="Witness" scope="props">
                                                <div class="Witness">
                                                    <div v-if="props.rowData.WitnessEmployeeID">
                                                        <span>{{props.rowData.WitnessEmployee.Person.Name}}</span>
                                                    </div>
                                                    <div v-else-if="EmployeeIDMatchesOtherID(props.rowData.DestroyingEmployeeID) == false">
                                                        <font-awesome-icon :icon="['fa', 'edit']" v-on:click="ShowDestructionEdit(props.rowData)" class="pointer" />
                                                        <span v-else @click="ShowDestructionWitness(props.rowData)" v-b-tooltip.hover title="Record Witness of Destruction" class="bold red pointer">PENDING</span>
                                                    </div>
                                                    <div v-else>
                                                        <span class="bold red">PENDING</span>
                                                    </div>

                                                </div>
                                            </template>
                                            <template slot="Delete" scope="props">
                                                <div class="Delete">
                                                    <DeleteIconRequest :requires-confirmation="true"
                                                                       confirmation-string="You are about to delete this record of destruction."
                                                                       :endpoint="'Medication/Destruction/' + props.rowData.Id"
                                                                       :payload="{}"
                                                                       v-on:success="GetDestructions(true)"
                                                                       method="DELETE" />
                                                </div>
                                            </template>
                                        </vuetable>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form>

                        <!--NEW DESTRUCITON MODAL-->
                        <b-modal ref="modal-newdestruction" size="md" title="MEDICATION DESTRUCTION" hide-footer>
                            <b-container>
                                <b-form @submit="SaveDestruction" v-if="TargetRecord.Id && TargetDestruction.MedicationInventoryID">
                                    <b-row>
                                        <b-col>
                                            <h3>INVENTORY INFO</h3>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h3>Pharmacy Info</h3>
                                            <div class="form-group">
                                                <label>Pharmacy Name:</label>
                                                <span>{{TargetRecord.PharmacyName}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Pharmacy Phone Number:</label>
                                                <span>{{TargetRecord.PharmacyPhoneNumber}}</span>
                                            </div>

                                        </b-col>
                                        <b-col>
                                            <h3>Refill Info</h3>
                                            <div class="form-group">
                                                <label>Rx Number:</label>
                                                <span>{{TargetRecord.PrescriptionNumber}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Quantity Filled (use actual in package):</label>
                                                <span>{{TargetRecord.QuantityFilled}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Refills Remaining:</label>
                                                <span>{{TargetRecord.RefillsRemaining}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Date Filled:</label>
                                                <span>{{TargetRecord.DateFilled}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Expiration Date:</label>
                                                <span>{{TargetRecord.ExpirationDate}}</span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h3>DESTRUCTION INFO</h3>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div class="form-group">
                                                <label>Date/Time of Duestruction:</label>
                                                <flat-pickr v-model="TargetDestruction.DestroyedAt" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                                            </div>
                                            <div class="form-group">
                                                <label>Quantity Destroyed:</label>
                                                <input type="number" v-model="TargetDestruction.QuantityDestroyed" step="0.1" class="form-control" required />
                                            </div>
                                            <div class="form-group">
                                                <label>Reason for Destruction:</label>
                                                <input type="text" v-model="TargetDestruction.Reason" class="form-control" required />
                                            </div>
                                            <div class="form-group">
                                                <label>Method of Destruction:</label>
                                                <input type="text" v-model="TargetDestruction.Method" class="form-control" required />
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <p class="red"><span class="bold">IMPORTANT:</span> All Medication destructions must have a non-client witness.  After witnessing the destruction, the witness should sign into OLIVER with their account, and return to the destruction section to record their witnessing of the destruction.</p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h4>This Medication Destruction is being performed by: <span class="bold">{{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</span></h4>
                                            <p>If you are not {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}, you must log out of the system and log in under your own profile.</p>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelDestruction()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="success" type="submit">
                                                RECORD DESTRUCTION
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>

                        <!--DESTRUCITON WITNESS MODAL-->
                        <b-modal ref="modal-newwitness" size="md" title="WITNESS OF MEDICATION DESTRUCTION" hide-footer>
                            <b-container>
                                <b-form @submit="SaveDestructionWitness" v-if="TargetRecord.Id && TargetDestruction.Id">
                                    <b-row>
                                        <b-col>
                                            <h3>Pharmacy Info</h3>
                                            <div class="form-group">
                                                <label>Pharmacy Name:</label>
                                                <span>{{TargetRecord.PharmacyName}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Pharmacy Phone Number:</label>
                                                <span>{{TargetRecord.PharmacyPhoneNumber}}</span>
                                            </div>

                                        </b-col>
                                        <b-col>
                                            <h3>Refill Info</h3>
                                            <div class="form-group">
                                                <label>Rx Number:</label>
                                                <span>{{TargetRecord.PrescriptionNumber}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Quantity Filled (use actual in package):</label>
                                                <span>{{TargetRecord.QuantityFilled}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Refills Remaining:</label>
                                                <span>{{TargetRecord.RefillsRemaining}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Date Filled:</label>
                                                <span>{{TargetRecord.DateFilled}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Expiration Date:</label>
                                                <span>{{TargetRecord.ExpirationDate}}</span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h3>DESTRUCTION INFO</h3>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div class="form-group">
                                                <label>Date/Time of Duestruction:</label>
                                                <span>{{TargetDestruction.DestoyedAt}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Quantity Destroyed:</label>
                                                <span>{{TargetDestruction.QuantityDestroyed}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Reason for Destruction:</label>
                                                <span>{{TargetDestruction.Reason}}</span>
                                            </div>
                                            <div class="form-group">
                                                <label>Method of Destruction:</label>
                                                <span>{{TargetDestruction.Method}}</span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h3>WITNESS INFO</h3>
                                            <div class="form-group">
                                                <label>Comments (optional):</label>
                                                <span>{{TargetDestruction.WitnessComments}}</span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <h4>This Medication Destruction was witnessed by: <span class="bold">{{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</span></h4>
                                            <p>If you are not {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}, you must log out of the system and log in under your own profile.</p>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="CancelDestructionWitness()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="success" type="submit">
                                                RECORD WITNESS OF DESTRUCTION
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </b-container>
                </b-modal>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import DeleteIconRequest from '../ItemEditors/DeleteIconRequest.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    

    export default {
        props: [

        ],
        data: function () {
            return {
                Filters: {
                    Status: "Present",
                },
                TargetRecord: {
                },
                TargetDestruction: {},
                TableOptions: {
                    Fields: [
                        {
                            name: 'PrescriptionNumber',
                            title: "Rx #",
                            sortField: 'PrescriptionNumber'
                        },
                        //{
                        //    name: 'DateFilled',
                        //    title: "Filled",
                        //    sortField: 'DateFilled',
                        //    //callback: 'formatDate'
                        //},
                        {
                            name: '__slot:DateFilled',
                            title: 'Filled',
                            sortField: "DateFilled"
                        },
                        {
                            name: 'QuantityFilled',
                            title: "Qty Filled",
                            sortField: 'QuantityFilled'
                        },
                        //{
                        //    name: 'ExpirationDate',
                        //    title: 'Expires',
                        //    //callback: 'formatDate',
                        //    sortField: 'ExpirationDate'
                        //},
                        {
                            name: '__slot:ExpirationDate',
                            title: 'Expires',
                            sortField: "ExpirationDate"
                        },
                        {
                            name: 'Status',
                            title: "Status",
                            sortField: 'Status'
                        },
                        {
                            name: '__slot:Edit',
                            title: 'Edit'
                        }
                    ]
                },
                DestructionTableOptions: {
                    Fields: [
                        {
                            name: 'DestroyedAt',
                            title: "Date/Time",
                        },
                        {
                            name: 'DestroyingEmployee.Person.FullName',
                            title: 'DestroyedBy',
                        },
                        {
                            name: '__slot:Witness',
                            title: 'DestroyedBy',
                        },
                        {
                            name: 'QuantityDestroyed',
                            title: "Qty",
                        },
                        {
                            name: 'Reason',
                            title: "Reason",
                        },
                        {
                            name: 'Method',
                            title: "Method",
                        },
                        {
                            name: '__slot:Delete',
                            title: 'Delete'
                        }
                    ]
                },
                DataList: [],
                Destructions: [],
                MedicationName: "",
                MedicationStrength: "",
                MedicationDoseDescription: "",
                OrderID: "",
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetList(true);
            },

            //ENDPOINTS
            GetList(displayLoad = false) {
                this.Filters.MedicationPhysicianOrderID = this.OrderID;
                this.$MasterAPI.ExecuteRequest("GET", "Medication/Inventory", this.Filters, this.GetListSuccess,()=>{}, displayLoad);
            },
            GetListSuccess(response) {
                this.DataList = response.data.data;
                this.$refs.datatableinv.refresh();
                
            },
            Save(e) {
                e.preventDefault();

                this.$MasterAPI.ExecuteRequest("POST", "Medication/Inventory", this.TargetRecord, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.GetList(true);
                this.$refs["modal-edit"].hide();
            },
            DeleteInventory() {
                this.$MasterAPI.ExecuteRequest("DELETE", "Medication/Inventory/" + this.TargetRecord.Id, {}, this.DeleteInventorySuccess, () => { }, true);
            },
            DeleteInventorySuccess() {
                this.GetList(true);
                this.$refs["modal-edit"].hide();
            },
            GetDestructions() {
                this.$MasterAPI.ExecuteRequest("GET", "Medication/Destruction/", { MedicationInventoryID: this.TargetRecord.Id }, this.GetDestructionsSuccess, () => { }, true);
            },
            GetDestructionsSuccess(response) {
                this.Destructions = response.data.data;
                this.$refs.datatabledest.refresh();
            },
            SaveDestruction(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Medication/Destruction/", this.TargetDestruction, this.SaveDestructionSuccess, () => { }, true);
            },
            SaveDestructionSuccess(response) {
                this.GetDestructions();
                this.$refs["modal-newdestruction"].hide();
            },
            SaveDestructionWitness(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Medication/Destruction/", this.TargetDestruction, this.SaveDestructionSuccess, () => { }, true);
            },
            SaveDestructionWitnessSuccess(response) {
                this.GetDestructions();
                this.$refs["modal-newwitness"].hide();
            },
            // UI

            ShowThis(orderID, medicationName, medicationStrength, medicationDoseDescription) {
                this.MedicationName = medicationName;
                this.MedicationStrength = medicationStrength;
                this.MedicationDoseDescription = medicationDoseDescription;
                this.OrderID = orderID;

                this.$MasterAPI.ExecuteRequest("GET", "Medication/Inventory", { MedicationPhysicianOrderID: orderID }, this.ShowThisSuccess, () => { }, true);
            },
            ShowThisSuccess(response) {
                this.DataList = response.data.data;
                
                this.$refs["modal-inventory"].show();
                this.GetList(true);
            },
            Cancel() {
                this.$refs["modal-inventory"].hide();
            },
            ShowNewInventory() {
                this.TargetRecord = {
                    MedicationPhysicianOrderID: this.OrderID
                };
                this.$refs["modal-edit"].show();
            },
            ShowEdit(rowData) {
                this.TargetRecord = JSON.parse(JSON.stringify(rowData));
                this.TargetRecord.PharmacyPhoneNumber = this.TargetRecord.PharmacyPhoneNumber.FormattedPhoneNumber;
                this.GetDestructions();
                this.$refs["modal-edit"].show();
            },
            CancelEdit() {
                this.$refs["modal-edit"].hide();
            },
            ShowNewDestruction() {
                this.TargetDestruction = {
                    MedicationInventoryID: this.TargetRecord.Id
                }
                this.$refs["modal-newdestruction"].show();
            },
            CancelDestruction() {
                this.$refs["modal-newdestruction"].hide();
            },
            ShowDestructionWitness(rowData) {
                this.TargetDestruction = JSON.parse(JSON.stringify(rowData));
                this.$refs["modal-newwitness"].show();
            },
            CancelDestructionWitness() {
                this.$refs["modal-newwitness"].hide();
            },
            // AUXILLARY
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                console.log("date formatted!!!");
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatableinv.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.DataList
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            DataManagerDestruction(sortOrder, pagination) {
                let dataset = this.Destructions
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            EmployeeIDMatchesOtherID(otherID) {
                let userID = this.UserPrivateProfile.EmployeeID;
                if (userID == otherID) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        components: {
            Vuetable,
            flatPickr,
            DeleteIconRequest
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>